// TODO(NLS): Call BE-defined setting when available
export const useSettingEnableNLSSearch = () => {
  return false;
};
